"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSoundBiteProperty = exports.soundBitePropertyDefinition = void 0;
exports.soundBitePropertyDefinition = {
    view: { label: 'Athlete quote' },
    constraints: [
        {
            name: 'maxLength',
            argument: 100,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'sound-bite',
};
const isSoundBiteProperty = (prop) => {
    return prop.name === exports.soundBitePropertyDefinition.name;
};
exports.isSoundBiteProperty = isSoundBiteProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic291bmQtYml0ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3NvdW5kLWJpdGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZUFBZSxFQUFFO0lBQ2hDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEdBQUc7U0FDZDtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxZQUFZO0NBQ2EsQ0FBQTtBQUkxQixNQUFNLG1CQUFtQixHQUFHLENBQUMsSUFBa0IsRUFBNkIsRUFBRTtJQUNuRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssbUNBQTJCLENBQUMsSUFBSSxDQUFBO0FBQ3ZELENBQUMsQ0FBQTtBQUZZLFFBQUEsbUJBQW1CLHVCQUUvQiJ9